// @flow

import qs from 'qs';
import Api from './ApiBase';

export const getListParams = (params: any) => qs.stringify({
  include: 'industry,logo_image_item',
  page: {
    limit: 3,
    ...params.page
  },
  ...params
});

class CompaniesApi extends Api {
  serializerType = 'companies';

  serializerOptions = {
    attributes: ['query']
  };

  fetch = async (params: {} = {}) => {
    const json = await this.request(`search_companies?${getListParams(params)}`);
    const data = await this.deserialize(json);

    return { data, meta: json.meta };
  }
}

export default new CompaniesApi();
